"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyProductConfiguration = void 0;
function makeEmptyProductConfiguration() {
    return {
        plan: '',
        revision: '',
        reportName: '',
        inspectionRequired: false,
        id: -1,
        code: '',
        name: '',
    };
}
exports.makeEmptyProductConfiguration = makeEmptyProductConfiguration;
//# sourceMappingURL=ProductConfiguration.js.map